
import { useEffect } from "react";
import { t } from "i18next";
import C from "Constants";
import usePaymentOptionSelection from "./PaymentOptions/usePaymentOptionSelection";


const PayLaterTab = ({ optionSelected , paymentOptions }) => {

  const { resetPaymentType, handleSelectPayLater } = usePaymentOptionSelection({
    setSelectedPaymentOptions: ()=>{},
  });

  useEffect(() => {
    if(optionSelected && (optionSelected === 2 || optionSelected?.id === C.PAY_LATER)){
        resetPaymentType();
        handleSelectPayLater(optionSelected);
    }
  } , [optionSelected])

  return (
    <div className="w-full flex flex-col gap-6 text-center align-center justify-center">
      <span className="text-20x text-dark-blue-900 font-bold">
        {t("Bon appétit! Sahtein")}
        <span className=" blinking-login-header px-2">{t("Enjoy!")}</span>{" "}
      </span>
      <img
        src={`${process.env.PUBLIC_URL}/images/fork-spoon-plate.svg`}
        alt="Fork and Spoon Icon"
        className="w-150x h-150x flex self-center"
      />
      <span className="text-16x font-medium text-dark-blue-900">
        {t("Scan QR Code later to pay anytime!")}
      </span>
    </div>
  );
};

export default PayLaterTab;
